import { Pipe, PipeTransform } from '@angular/core';
import {ValueFormatter} from "../ValueFormatter";

@Pipe({
  name: 'autoFormat'
})
export class AutoFormatPipe implements PipeTransform {

  transform(value: number, unit: string): string {

    return ValueFormatter.autoFormat(value, unit );
  }

}
